/* ----------------------------

Init Select2 Plugin with custom options

---------------------------- */

$(document).ready(function(){

	// homepage select2 elements
	$('.sort-util--select').select2({
		allowClear: true
	});
	
	// select2 multi select init
	$('.select2--multi-select').select2({
		allowClear: true,
		multiple: true
	});
	
	// select2 simple select box - no search
	$('.select2--simple-select').select2({
		minimumResultsForSearch: -1
	});
	
	// select2 default select box - has search
	$('.select2--default-select').select2();
	
});